function unselectAll() {
  if (document.selection) {
    document.selection.empty();
  }
  if (window.getSelection) {
    window.getSelection().removeAllRanges();
  }
}

function showLargeNotificationPanel() {
  document.getElementById('largeNotificationPanel').style.visibility = 'visible';
}

export default { showLargeNotificationPanel, unselectAll };
